import React from "react"
import { useIntersectionObserver } from "../../hooks/useScroll"
import { classNames } from "../../utils/classNames"

const Section = ({ children, id, className = "" }) => {
  const [sectionRef, isVisible] = useIntersectionObserver(0.1)

  return (
    <section
      id={id}
      ref={sectionRef}
      className={classNames(
        "py-16 md:py-24 transition-opacity duration-1000 ease-in-out transform",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10",
        className
      )}
    >
      <div className="container mx-auto px-6 lg:px-8">{children}</div>
    </section>
  )
}

export default Section
